<template>
  <div>
    <template v-for="item in nav">
      <router-link
        v-if="typeof routes[item.name] === 'string' && hasPermission(item.permission)"
        :key="item.name"
        class="nav-link tw-mx-2 tw-font-semibold"
        :to="{ name: routes[item.name] }"
      >
        {{ item.name }}
      </router-link>
      <a
        v-else-if="routes[item.name]?.href && hasPermission(item.permission)"
        :key="`A${item.name}`"
        class="nav-link tw-mx-2 tw-font-semibold"
        :href="routes[item.name].href"
      >
        {{ item.name }}
      </a>
    </template>
  </div>
</template>

<script setup>
import { hasPermission } from '@/logic/common/Permissions'
import { ticketsBaseUrl } from '@/logic/common/urls'

const routes = {
  Clients: 'Clients',
  Tasks: 'Tasks',
  Groepen: 'view-groups',
  Gebouwen: 'buildings',
  PlanBaas: { href: `${ticketsBaseUrl}/v2/planner?use_erp_menu=true` },
  Tickets: { href: `${ticketsBaseUrl}/v2/tickets?use_erp_menu=true` },
  Alarmen: 'alarms',
  Cases: 'cases',
  Polling: 'polling',
  'Purchase Orders': 'purchase-orders',
  Projecten: { href: `${ticketsBaseUrl}/v2/projects?use_erp_menu=true` },
  'Finished tasks': { href: `${ticketsBaseUrl}/v2/finished-tasks?use_erp_menu=true` },
  Gebruikers: { href: `${ticketsBaseUrl}/v2/users?use_erp_menu=true` },
  'Call Centre': 'Call Centre',
  IPAs: { href: `${ticketsBaseUrl}/v2/partners?use_erp_menu=true` },
  Commercie: { href: `${ticketsBaseUrl}/v2/customers?use_erp_menu=true` },
  Logistiek: { href: `${ticketsBaseUrl}/v2/logistics?use_erp_menu=true` },
  'Energieleveren.nl': { href: `${ticketsBaseUrl}/v2/energieleveren?use_erp_menu=true` },
}

const nav = [
  { name: 'Clients', permission: 'ERP_VIEW_SCREEN_CLIENTS' },
  { name: 'Tasks', permission: 'ERP_VIEW_SCREEN_TASKS' },
  { name: 'Call Centre', permission: 'ERP_VIEW_SCREEN_CALL_CENTRE' },
  { name: 'Groepen', permission: 'ERP_VIEW_SCREEN_CLIENTS' },
  { name: 'Gebouwen', permission: ['ERP:view_buildings'] },
  { name: 'Alarmen', permission: ['Eleena:view_alarms'] },
  { name: 'Cases', permission: ['Tickets:view_cases'] },
  { name: 'Polling', permission: ['ERP:view_polling'] },
  { name: 'Purchase Orders', permission: ['ERP:view_purchase_orders'] },
  { name: 'Projecten', permission: 'ERP_VIEW_SCREEN_PROJECTS' },
  { name: 'Finished tasks', permission: ['Tickets:view_locations'] },
  { name: 'Gebruikers', permission: ['ERP:list_users'] },
  { name: 'PlanBaas', permission: ['Tickets:view_planner'] },
  { name: 'Tickets', permission: ['tickets_v2'] },
  { name: 'IPAs', permission: ['Tickets:view_installation_partners'] },
  // Any of the three tabs the section holds is reason enough to show it; which tabs
  // then appear is decided in the tickets CustomersView with the same three rights.
  { name: 'Commercie', permission: ['Tickets:list_customers', 'Tickets:view_exact_bouw_prices', 'Tickets:view_customer_quotes'] },
  // Logistiek groups the former Voorraad, Artikelen and Bestellingen entries as tabs.
  { name: 'Logistiek', permission: ['Tickets:view_warehouses', 'Tickets:view_items', 'partner_orders_manager', 'partner_orders_basic'] },
  { name: 'Energieleveren.nl', permission: ['Tickets:view_energieleveren'] },
]
</script>

<style lang="scss" scoped>
::v-deep .nav-link {
  display: inline-block;
  position: relative;
  color: #5d0e07;
}

.nav-link.router-link-active {
  color: #fdd6ba;
  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    width: 20px;
    height: 2px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fdd6ba;
  }
}
</style>
